import React from 'react';

import { Modal } from 'src/components/common';
import { InviteVerifiersAdminsByCVAdminModalForm } from 'src/components/verifierStaff';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const InviteVerifiersAdminsByCVAdminModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(
    ModalId.InviteVerifiersAdminsByCVAdmin,
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite Verifier"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InviteVerifiersAdminsByCVAdminModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
